var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{attrs:{"defaultActiveKey":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"CONSULTA EMPLEADO"}},[_c('informacion-empleado',{on:{"contractSelected":_vm.contractSelected}}),_vm._v(" "),(_vm.idEmp)?_c('dotaciones',{attrs:{"empleadoseleccionado":_vm.idEmp}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081a2df2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/customization/GlobalBPOCore/pages/Dotaciones/ConsultaEmpleado.vue
// module id = null
// module chunks = 